import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { S, toast } from "../store.ts";

interface Ref { code: string; link: string; joined: number; rewarded: number; rewardDays: number; cap: number; capped: boolean }

/** "Invite a friend": one link, +7 days for both families once the friend has tried Numi. */
export function Invite() {
  const [r, setR] = useState<Ref | null>(null); const [fail, setFail] = useState(false);
  useEffect(() => { api<Ref>("/referral").then(setR).catch(() => setFail(true)); }, []);
  if (fail) return null;
  if (!r) return <p className="note">Loading your invite link...</p>;
  const kid = S.child?.name || "my child";
  const text = `${kid} has been learning maths with Numi, a friendly AI maths tutor for Classes 1–5. Try it free for 7 days: ${r.link}`;
  const copy = async () => { try { await navigator.clipboard.writeText(r.link); toast("Link copied"); } catch { toast("Press and hold the link to copy it"); } };
  return <div className="invite">
    <p className="note">Know a family who would like Numi? When they sign up and their child tries a few questions, <b>both of you get {r.rewardDays} more days</b> and your child gets a "Friend of Numi" sticker.</p>
    <div className="row"><input className="inp" readOnly value={r.link} aria-label="Your invite link" onFocus={(e) => e.currentTarget.select()} style={{ maxWidth: 300 }} />
      <button className="btn soft" onClick={copy}>Copy link</button>
      <a className="btn yellow" href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer">Share on WhatsApp</a></div>
    <p className="note">{r.joined ? `${r.joined} ${r.joined === 1 ? "family has" : "families have"} joined with your link, ${r.rewarded} earned you the bonus.` : "No one has joined yet."}{r.capped ? ` You've earned the maximum of ${r.cap} bonuses. Thank you!` : ""}</p>
  </div>;
}
